<template>
<div :class="itemClass">
    <div class="cfd-header" @click="headerClickHandler">
        <div class="cfd-ticker">{{ instrument[nameKey].Text }}</div>
        <div class="cfd-name">{{ instrument.LocalizedName.Text }}</div>
        <div class="cfd-icon">
            <svg class="cfd-more" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
                <path d="M0 0h24v24H0z" fill="none"/>
            </svg>
        </div>
    </div>
    <transition name="slide" @enter="enter" @after-enter="afterEnter" @leave="leave" @after-leave="afterLeave">
        <div class="cfd-body" ref="body" v-show="isOpened">
            <InstrumentsListItemData ref="data" :instrument="instrument"/>
        </div>
    </transition>
</div>
</template>

<script>
import InstrumentsListItemData from './InstrumentsListItemData.vue';

export default {
    name: 'InstrumentsListItem',

    components: {
        InstrumentsListItemData
    },

    props: {
        instrument: {
            type: Object,
            required: true
        },

        nameKey: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            isOpened: false,
            enterActive: false,
            leaveActive: false
        };
    },

    computed: {
        itemClass () {
            return {
                'cfd-item': true,
                'is-opened': this.isOpened,
                'is-enter-active': this.enterActive,
                'is-leave-active': this.leaveActive
            };
        }
    },

    methods: {
        headerClickHandler () {
            this.isOpened = !this.isOpened;
        },

        enter () {
            this.leaveActive = false;
            this.enterActive = true;
            this.$refs.body.style.height = '0';
            setTimeout(() => {
                this.$refs.body.style.height = `${this.$refs.data.$el.clientHeight}px`;
            }, 5);
        },

        afterEnter () {
            this.$refs.body.style.height = 'auto';
            this.enterActive = false;
        },

        leave () {
            this.enterActive = false;
            this.leaveActive = true;
            this.$refs.body.style.height = `${this.$refs.data.$el.clientHeight}px`;
            setTimeout(() => {
                this.$refs.body.style.height = '0';
            }, 5);
        },

        afterLeave () {
            this.$refs.body.style.height = '';
            this.leaveActive = false;
        }
    }
};
</script>

<style scoped>
.cfd-item.is-opened,
.cfd-item.is-enter-active,
.cfd-item.is-leave-active {
    margin-top: -1px;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
}

.cfd-item.is-opened:first-child,
.cfd-item.is-enter-active:first-child,
.cfd-item.is-leave-active:first-child {
    margin-top: 0;
    border-top: 0;
}

.cfd-item.is-opened:last-child,
.cfd-item.is-enter-active:last-child,
.cfd-item.is-leave-active:last-child {
    border-bottom: 0;
}

.cfd-header {
    position: relative;
    z-index: 1;
    padding: 16px 56px 16px 16px;
    cursor: default;
}

.cfd-ticker {
    font-size: 16px;
    line-height: 20px;
}

.cfd-name {
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, .54);
}

.cfd-icon {
    position: absolute;
    z-index: 1;
    top: 24px;
    right: 16px;
    width: 24px;
    height: 24px;
    opacity: .54;
    transition: transform .5s ease-in;
}

.cfd-item.is-opened .cfd-icon {
    transform: rotateZ(180deg);
    transition-timing-function: ease-out;
}

.cfd-body {
    overflow: hidden;
}

.cfd-item.is-opened .cfd-icon {
    transform: rotateZ(180deg);
}

.slide-enter-active,
.slide-leave-active {
    transition-property: height;
    transition-duration: .5s;
}

.slide-enter-active {
    transition-timing-function: ease-out;
}

.slide-leave-active {
    transition-timing-function: ease-in;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/InstrumentsListItem.vue